import { call, put, take, select } from "redux-saga/effects";

import { MODAL_TYPES } from "../constants/modals";
import { getUserId } from "../selectors";
import firebase from "../services/firebase";
import * as actions from "../constants/actions";
import * as actionTypes from "../constants/actionTypes";

export function* createFolder({ payload }) {
  const { values, resolve, reject } = payload;
  const { title } = values;
  const userId = yield select(getUserId);

  const { error } = yield call(firebase.folder.create, { userId, title });

  if (error) {
    reject(error);
  } else {
    resolve();

    yield put(actions.closeModal());
    yield put(actions.fetchFolders());
  }
}

export function* updateFolder({ payload }) {
  const { values, resolve, reject } = payload;
  const { id, title } = values;
  const { error } = yield call(firebase.folder.update, { id, title });

  if (error) {
    reject(error);
  } else {
    resolve();
    yield put(actions.closeModal());
    yield put(actions.fetchFolders());
  }
}

export function* fetchFolders() {
  const userId = yield select(getUserId);
  const { error, folders } = yield call(firebase.folder.fetch, { userId });

  if (error) {
    // yield error
  } else {
    yield put(actions.setFolders({ folders }));
  }
}

export function* deleteFolder({ payload }) {
  yield put(
    actions.openModal({
      modalType: MODAL_TYPES.DELETE_FOLDER_CONFIRMATION
    })
  );

  const { type } = yield take([
    actionTypes.MODAL_CONFIRMED,
    actionTypes.MODAL_CLOSE
  ]);

  if (type !== actionTypes.MODAL_CONFIRMED) {
    return;
  }

  const { id } = payload;
  const { error } = yield call(firebase.folder.destroy, { id });

  yield put(actions.closeModal());

  if (error) {
    // TODO: handle error in UI
  } else {
    yield put(actions.unsetFolder({ id }));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/folders.js